<template>
<div id="identificadores_complementos" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Identificadores y Complementos" class="elevation-1 px-5 py-3" >
          <br>
          <v-row row wrap>
              <v-col sm="12" md="6">
                  <v-autocomplete v-model="model.rfc" :items="rfcs" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="RFC" @change="set_rfc()" :rules="[rules.required]">
                  </v-autocomplete>
              </v-col>
          </v-row>

          <v-tabs v-if="model.rfc != '' && rfc != ''" grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab key="reportesGlobal" @click="tipo=1;" >Reporte de Identificadores a Nivel Global</v-tab>
            <v-tab key="reportesPartida" @click="tipo=2;" >Reporte de Identificadores a Nivel Partida</v-tab>
            <v-tab key="apendice" >Apéndice 8</v-tab>

            <v-tab-item key="reportesGlobal" >
              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col xs="12" sm="6" md="6" lg="6" >
                          <v-autocomplete v-model="model.reporte_url" :items="list_reportes" :hide-no-data="true" :return-object="false" item-text="reporte" item-value="url" label="Tipo de Reporte" @change="setNombreReporte()"
                              :rules="[rules.required]" >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row row wrap>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-text>
                          <v-expansion-panels hover>
                              <v-expansion-panel>
                                  <v-expansion-panel-header style="font-weight:bold!important;" >Apéndice 8: Identificadores Nivel Global&nbsp;&nbsp;<span style="font-size:12px!important;color:#ff5252!important" v-show="validaIdentificador" >Seleccione una clave</span></v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                      <v-checkbox v-model="selecciona_todo8" label="Seleccionar Todo" @change="seleccionaTodo8('G')" ></v-checkbox>
                                      <br/>
                                      <v-row no-gutters dense style="margin-bottom: -35px;" >
                                          <v-col cols=2 v-for="(forma, index) in arr_claves_casos_global" :key="'contri'+index" >

                                          <v-checkbox v-model="model.claves_casos" :label="forma.clave" :value="forma.clave"
                                          :rules="index==0?[verificaClavesCasos]:[]" >
                                          </v-checkbox>

                                          </v-col>
                                      </v-row>
                                  </v-expansion-panel-content>
                              </v-expansion-panel>
                          </v-expansion-panels>
                      </v-card-text>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportes" />
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item key="reportesPartida" >
              <div class="contenedor-tab-diaria" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col xs="12" sm="6" md="6" lg="6" >
                          <v-autocomplete v-model="model.reporte_url" :items="list_reportes_partidas" :hide-no-data="true" :return-object="false" item-text="reporte" item-value="url" label="Tipo de Reporte" @change="setNombreReportePartida()"
                              :rules="[rules.required]" >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row row wrap>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)"
                                  v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu3 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu4 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>
                      <v-card-text>
                          <v-expansion-panels hover>
                              <v-expansion-panel>
                                  <v-expansion-panel-header style="font-weight:bold!important;" >Apéndice 8: Identificadores Nivel Partida&nbsp;&nbsp;<span style="font-size:12px!important;color:#ff5252!important" v-show="validaIdentificadorPartida" >Seleccione una clave</span></v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                      <v-checkbox v-model="selecciona_todo8_partida" label="Seleccionar Todo" @change="seleccionaTodo8('P')" ></v-checkbox>
                                      <br/>
                                      <v-row no-gutters dense style="margin-bottom: -35px;" >
                                          <v-col cols=2 v-for="(forma, index) in arr_claves_casos_partida" :key="'contri'+index" >

                                          <v-checkbox v-model="model.claves_casos_partida" :label="forma.clave" :value="forma.clave"
                                          :rules="index==0?[verificaClavesCasos]:[]" >
                                          </v-checkbox>

                                          </v-col>
                                      </v-row>
                                  </v-expansion-panel-content>
                              </v-expansion-panel>
                          </v-expansion-panels>
                      </v-card-text>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="generar_reporte_sqs" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportesPartida" />
                  <v-client-table ref="vuetable" :data="datos.reportesPartidas" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item key="apendice" >
              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                    <span class="subheading" >
                          <strong>Apéndice 8: Identificadores</strong>
                      </span>
                  </v-card-title>
                    <v-container grid-list-md text-xs-center>
                      <v-client-table id="apendice8table" ref="vuetableApendice" :data="arr_claves_casos" :columns="columnsApendice" :options="OptionscolumnsApendice" class="elevation-2 pa-2" >
                          <template slot="noResults" >
                              <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                          </template>
                          <template slot="descripcion" slot-scope="props" >
                              <div class="columnadescripcion" >
                              {{ props.row.descripcion }}
                              </div>
                          </template>
                          <template slot="supuesto" slot-scope="props" >
                              <div class="columnasupuesto" >
                              {{ props.row.supuesto }}
                              </div>
                          </template>
                      </v-client-table>
                    </v-container>
                    <v-card-text>

                      </v-card-text>

                </v-card-text>
              </div>
            </v-tab-item>

          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.tipo = 1;
    this.model.usuario = this.$local_storage.get("id_usuario");

    this.cargarClavesCasos();
    this.get_clientes_grupo();
  },
  computed: {
    arr_claves_casos_global(){
      var items = this.arr_claves_casos;
      var result = items.filter(item => item.nivel == 'G');
      return result;
    },
    arr_claves_casos_partida(){
      var items = this.arr_claves_casos;
      var result = items.filter(item => item.nivel == 'P');
      return result;
    },
  },
  data: () => ({
    fab: false,
    rfcs: [],
    columnsApendice: [
        "clave",
        "descripcion",
        "nivel",
        "supuesto",
        "complemento1",
        "complemento2",
        "complemento3",
    ],
     OptionscolumnsApendice: {
        filterable: ["clave",
        "descripcion",
        "nivel",
        "supuesto",
        "complemento1",
        "complemento2",
        "complemento3",],
      sortable: ["clave",
        "descripcion",
        "nivel",
        "supuesto",
        "complemento1",
        "complemento2",
        "complemento3",],

       headings:{ "clave":"Clave",
        "descripcion": "Descripción",
        "nivel": "Nivel",
        "supuesto" :"Supuesto",
        "complemento1" : "Complemento 1",
        "complemento2" : "Complemento 2",
        "complemento3" : "Complemento 3" }
     },
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/admin"
      },
      {
        text: "Identificadores y Complementos",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: [],
      reportesPartidas: [],
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "",
      nombre_reporte: "",
      tipo: "Identificadores_Global",
      claves_casos: [],
      claves_casos_partida: [],
      opc_impo: 1,
      opc_expo: 1,
    },
    arr_claves_casos: [],
    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    validaIdentificador:false,
    validaIdentificadorPartida:false,
    list_reportes: [
      {
        "reporte": "DS Identificador Global - Filtro por Clave Caso",
        "url": "/reportes_ds/identificadores_global_ds/"
      },
      {
        "reporte": "WS Identificador Global - Filtro por Clave Caso",
        "url": "/reportes_ws/identificadores_global_ws/"
      },

    ],
    list_reportes_partidas: [
      {
        "reporte": "DS Identificador Partida - Filtro por Clave Caso",
        "url": "/reportes_ds/identificadores_ds/"
      },
      {
        "reporte": "WS Identificador Partida - Filtro por Clave Caso",
        "url": "/reportes_ws/identificadores_ws/"
      },

    ],
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
  }),
  methods: {
    set_rfc: function() {
      this.rfc = this.model.rfc;

      this.cargarReportes();
      this.cargarReportesPartida();

    },
    verificaClavesCasos: function(){
        //Validar reporte seleccionado
        if(this.tipo==1 && !['/reportes_ds/identificadores_global_ds/','/reportes_ws/identificadores_global_ws/'].includes(this.model.reporte_url)){
          this.model.reporte_url = "";
        }else if(this.tipo==2 && !['/reportes_ds/identificadores_ds/','/reportes_ws/identificadores_ws/'].includes(this.model.reporte_url)){
          this.model.reporte_url = "";
        }
        //Validar claves casos seleccionados
        if ((this.model.reporte_url=='/reportes_ds/identificadores_ds/' || this.model.reporte_url=='/reportes_ws/identificadores_ws/') && this.model.claves_casos_partida.length == 0){
            this.validaIdentificadorPartida = true;
            return "Seleccione una clave";
        } else if((this.model.reporte_url=='/reportes_ds/identificadores_global_ds/' || this.model.reporte_url=='/reportes_ws/identificadores_global_ws/') && this.model.claves_casos.length == 0){
            this.validaIdentificador = true;
            return "Seleccione una clave";
        } else {
            this.validaIdentificador = false;
            this.validaIdentificadorPartida = false;
            return true;
        }
    },
    seleccionaTodo8: function(nivel_seleccionado){
      var thisObj = this;
      if(nivel_seleccionado == "G"){
        if (this.selecciona_todo8 == true){
            this.arr_claves_casos.forEach(e => {
                if (e.nivel == nivel_seleccionado)
                  thisObj.model.claves_casos.push(e.clave);
            });
        }
        else
          this.model.claves_casos = [];

      } else if(nivel_seleccionado == "P"){
          if (this.selecciona_todo8_partida == true){
              this.arr_claves_casos.forEach(e => {
                  if (e.nivel == nivel_seleccionado)
                    thisObj.model.claves_casos_partida.push(e.clave);
              });
          }
          else
            this.model.claves_casos_partida = [];
      }
    },
    cargarClavesCasos: function () {
        axios.post(this.$hostname+ "apendices/lista/", {tabla:16})
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.arr_claves_casos = res.data;
                    this.arr_claves_casos.sort(function (a, b) {
                        //Ordenar por clave ascendente
                        return a.clave - b.clave ;
                    });
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener las claves de identificadores.",
                    footer: ""
                });
                console.log(err);
            })
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    generar_reporte_sqs() {
      this.verificaClavesCasos();
      if (!this.$refs.form.validate() || this.validaIdentificador==true || this.model.reporte_url == "") {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        if (this.tipo == 1){
          this.model.tipo = "Identificadores_Global";
        } else {
          this.model.tipo = "Identificadores_Partida";
        }
        var data = Vue.util.extend({}, this.model); //Clonamos el modelo, para no desagrupar los filtros de contribuciones
        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargarReportes();
            this.cargarReportesPartida();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Identificadores_Global"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarReportesPartida: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Identificadores_Partida"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportesPartidas = res.data;
            this.datos.reportesPartidas.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportesPartidas) {
              this.datos.reportesPartidas[k].fecha_solicitud = this.parseDate(this.datos.reportesPartidas[k].fecha_solicitud);
              this.datos.reportesPartidas[k].fecha_generacion = this.parseDate(this.datos.reportesPartidas[k].fecha_generacion);
              this.datos.reportesPartidas[k].estatus = this.getEstatus(this.datos.reportesPartidas[k].estatus);
              this.datos.reportesPartidas[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportesPartidas[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
              this.cargarReportesPartida();
            });
        }
      });
    },
    setNombreReporte: function() {
      var url = this.model.reporte_url
      var search = this.list_reportes.filter(function(e) {
        return e.url == url;
      });
      if (search.length > 0) {
        this.model.nombre_reporte = search[0].reporte;
      }
      //this.selecciona_todo8 = false;
    },
    setNombreReportePartida: function() {
      var url = this.model.reporte_url
      var search = this.list_reportes_partidas.filter(function(e) {
        return e.url == url;
      });
      if (search.length > 0) {
        this.model.nombre_reporte = search[0].reporte;
      }
      //this.selecciona_todo8_partida = false;
    },
    get_clientes_grupo: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
          usuario: this.$local_storage.get("id_usuario"),
          sistema: this.$sistema,
      };

      axios.post(this.$hostname + "usuarios/get_clientes_grupo/", data)
        .then(res => {
          if (res.data != undefined) {
            this.rfcs= res.data;
          } else {
            this.rfcs = [];
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los RFC del Grupo.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control{
    margin-bottom: -35px;
}
.elevation-1 >>> .v-input--has-state > div:nth-child(1) > div:nth-child(2){
    margin-top: -10px;
}
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light{
    font-size: 10px !important;
}
.v-card__text  >>> .columnadescripcion {
  white-space: normal !important;
  max-width: 300px !important;
}
.v-card__text  >>> .columnasupuesto  {
  white-space: normal !important;
  max-width: 450px !important;
}
</style>
